import React, { useState } from "react";
import lodash from "lodash";
import { Field } from "formik";
import { usePost } from "seed/api";
import DynamicSelectField from "components/util/schema_form/fields/DynamicSelectField";
import BaseField from "components/util/schema_form/fields/BaseField";
import { Loading } from "seed/helpers";


const RecursiveSelectField = ({
  name,
  label,
  values,
  value,
  required,
  caption,
  helpMessage,
  setFieldValue,
  actionId,
  flowId,
  optionsCall,
  selectCall,
}) => {

  const userId = sessionStorage.getItem("id");
  const [queue, setQueue] = useState([{ label: "", value: "" }])
  const [queueLog, setQueueLog] = useState([""])
  const [selection, setSelection] = useState(null)
  const baseSelectorName = name + "_recursive_subselector"

  const [callCall, reqCall] = usePost(`/call/${actionId}/${selectCall}`, {
    onCompleted: (data) => {
      setSelection(data)
      if (data) setFieldValue(name, data)
    }
  })

  const onChangeSelect = (idx, value, label) => {
    const newValue = {
      value: value,
      label: label
    }
    setQueue([...queue.slice(0, idx + 1), newValue])
    callCall({
      user_id: parseInt(userId),
      flow_id: parseInt(flowId),
      values: values,
      call_params: label,
    })

    if (queueLog.indexOf(value) == -1)
      setQueueLog([...queueLog, value])
  }

  const onClickBreadCrumb = (idx) =>
    setQueue([...queue.slice(0, idx + 1)])


  return (
    <BaseField
      name={name}
      label={label}
      values={values}
      required={required}
      caption={caption}
      helpMessage={helpMessage}
      enableComments={false}
      setFieldValue={setFieldValue}>
      
      {/* Hidden field to force form required validation */}
      <Field type={"text"} value={value || ""} className="hidden-field" required={required} />

      {queue.length > 1 &&
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb breadcrumb-no-gutter mb-1">
            {queue.map((item, idx) =>
              <li key={idx} class="breadcrumb-item">
                <a class="breadcrumb-link" style={{ cursor: 'pointer' }}
                  onClick={() => onClickBreadCrumb(idx)}>
                  {item.label}
                </a>
              </li>)}
          </ol>
        </nav>}

      {selection == null &&
        queueLog.map((item, idx) =>
          <div key={item} className={item == queue[queue.length - 1].value ? "d-block" : "d-none"}>
            {!reqCall.loading ?
              <DynamicSelectField
                name={baseSelectorName + "_" + idx}
                flowId={flowId}
                actionId={actionId}
                values={values}
                value={lodash.get(values, baseSelectorName + "_" + idx)}
                setFieldValue={setFieldValue}
                dynamicOptions={{
                  source: "CALL",
                  value: optionsCall,
                  call_params: item
                }}
                onChange={(value, label) => onChangeSelect(idx, value, label)}
              /> : <div className="mt-4"><Loading size={21} /></div>}
          </div>
        )}
    </BaseField>
  )
}

export default RecursiveSelectField;